import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import styles from './html.css'

function HTMLHeader({ isFirstComponent }) {
  return (
    <div className={classnames(styles.headerContainer, { [styles.firstComponent]: isFirstComponent })}>
      <div className={styles.headerContent}>
        <span className={styles.header}>New to Neon. Already legendary</span>
        <div className={styles.subHeaderGroup}>
          <p className={styles.subHeader}>
            From iconic films to cult series, we&apos;ve added more of the all-time greats. The comfort watches and classics you&apos;ll keep coming back to.
          </p>
        </div>
      </div>
    </div>
  )
}

HTMLHeader.propTypes = {
  isFirstComponent: PropTypes.bool
}

HTMLHeader.defaultProps = {
  isFirstComponent: false
}

export default HTMLHeader
